import * as React from 'react';

import {TwoPaneModal} from 'shells/modal/two-pane-modal';

import type {MeetingUpdateInput, MeetingFragment} from 'nutshell-graphql-types';

import {MODAL_CONTENT_MAP, ILLUSTRATION_MAP, WINDOW_SIZE_MAP} from './consts';

import styles from './conferencing-modal-wrapper.module.css';

export type ConferencingModalType = 'ZOOM' | 'MEET' | 'TEAMS';

type Props = {
    modalType: ConferencingModalType;
    closeModal: () => void;
    meeting: MeetingFragment;
    onSave?: (arg1: MeetingUpdateInput) => void;
    onFailToConnect?: () => void;
};

export function ConferencingModalWrapper(props: Props) {
    const {modalType, meeting, ...restProps} = props;

    const ModalContent = MODAL_CONTENT_MAP[modalType];
    const Illustration = ILLUSTRATION_MAP[modalType];
    const windowFeatures = {
        toolbar: 'no',
        location: 'no',
        ...WINDOW_SIZE_MAP[modalType],
    } as const;

    return (
        <TwoPaneModal
            // @ts-expect-error
            isOpen={true}
            maxHeight={500}
            closeButton={false}
            leftSection={
                <div className={styles.left}>
                    <Illustration size={120} />
                </div>
            }
            onClose={props.onFailToConnect || props.closeModal}
            rightSection={
                <div className={styles.container}>
                    {/* @ts-expect-error */}
                    <ModalContent
                        meetingId={meeting.id}
                        windowFeatures={windowFeatures}
                        {...restProps}
                    />
                </div>
            }
        />
    );
}
